import { h } from 'preact';
import * as BaseComp from 'components/bolt/header/header.js';
import { findInVNode } from 'utils/vnode';
import Store from 'store/store';
import { joinClasses } from 'utils/utils';
import Button from 'components/bolt/button/button';

import s from 'components/bolt/header/header.sss';

export default class Header extends BaseComp.default {
    constructor(props) {
        super(props);
        this.state = {
			...this.state,
            isNavOpen: false
        };
    }

    renderHeaderLogo() {
		const headerLogo = this.props?.appData?.header?.powsterHeader?.logo;
		// const isDesktopSize = this.props?.client?.isDesktopSize;
		if (!headerLogo) return;

		const { pageExclusions, pageInclusions, path, sameWindow, src, alt } = headerLogo;

		const headerLogoExclusions = (pageExclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		const headerLogoInclusions = (pageInclusions || '').split(',')?.map(e => e.trim())?.filter(e => e);
		const activePage = Store.get().activePage;

		let hideHeaderLogo;
		if (headerLogoInclusions.length > 0) {
			hideHeaderLogo = !headerLogoInclusions.includes(activePage);
		} else {
			hideHeaderLogo = headerLogoExclusions.includes(activePage);
		}

		const navOpen = this.state.isNavOpen;
		const className = joinClasses(s.headerLogo, navOpen && s.navOpen, hideHeaderLogo && s.hide, !headerLogo.path && s.unclickable, );
		const content = <img src={src} alt={alt} />;

		if (/^(https?:\/\/|mailto:)/i.test(path)) {
			return (
				<a
					class={className}
					href={path}
					target={sameWindow ? '_self' : '_blank'}
					rel="noopener noreferrer"
					onClick={() => this.trackPersistentButtonClick(path, alt || 'headerLogo')}
					key="headerLogoLink"
				>
					{content}
				</a>
			);
		}

		return (
			<Button
				class={className}
				trigger={e => path && this.triggerPersistentButton(path, 'Logo', sameWindow, e)}
				key="headerLogoBtn"
			>
				{content}
			</Button>
		);
	}

    render(props) {
		const { thankYouScreenShown } = props.headerData;
		let newProps = props;
		newProps.solidBackground = false;
		const base = super.render(newProps);
		const container = findInVNode(base, '[key="container"]');
		if (container && thankYouScreenShown) {
			container.attributes.class += ` ${s.thankYouScreenShown}`; 
		}
        // Check if the 'expand' child with 'navOpen' attribute is present
        const expandChild = container && findInVNode(container, '[key="expand"]');
        const isNavOpen = expandChild && expandChild.attributes.navOpen;
        

		const newIsNavOpen = !!isNavOpen;
		if (newIsNavOpen !== this.state.isNavOpen) {
			this.setState({ isNavOpen: newIsNavOpen }, () => {
			});
		}

		return base;
	}

}
